// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R_ABl","left":"styles_left__3yEU_"};